import { createPortal } from 'react-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function GlobalToast() {
  const toastRoot = document.getElementById('toast-root');
  if (!toastRoot) return null;

  return createPortal(
    <ToastContainer
      position="top-right"
      autoClose={false}
      newestOnTop
      closeOnClick
      pauseOnHover
      draggable
      theme="light"
    />,
    toastRoot
  );
}
